import { css } from '@/styled-system/css';

export const inputChipLabelStyles = css.raw({
  color: 'Chip.label.default',
  hyphens: 'auto',
  textStyle: 'body-sm-bold',
  paddingBlock: 'Chip.padding.vert',
});
